import { FilterTypeKey, FilterType, INumberFilter, IStringFilter } from '../../components/filters-menu/filters';

export const bidderTrafficFilters = new Map<FilterTypeKey, FilterType>([
	[
		'numberFilters',
		{
			id: { columnName: 'ID', cellKey: 'id' },
		} as INumberFilter,
	],
	[
		'stringFilters',
		{
			geo: { columnName: 'Geo', cellKey: 'geo' },
			op_system: { columnName: 'Operating System', cellKey: 'op_system' },
			browser: { columnName: 'Browser', cellKey: 'browser' },
			device_type: { columnName: 'Device Type', cellKey: 'device_type' },
		} as IStringFilter,
	],
]);
